/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { put } from 'redux-saga/effects'
import { getUserInfo } from '../../../actions/auth'

export default function*() {
  yield put.resolve(getUserInfo())
}
